/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/first-line-1-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "FirstLine1Rec";
export { I as FirstLine1Rec };
